import { rankingItems } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";

const tagStyles: Record<string, string> = {
  热: "bg-primary-500 text-background-50",
  新: "bg-accent-500 text-foreground-950",
  证: "bg-secondary-500 text-background-50",
  鉴: "bg-secondary-100 text-secondary-900",
  图: "bg-accent-100 text-accent-900",
  梳: "bg-primary-100 text-primary-900",
};

export default function RankingSection() {
  return (
    <section id="ranking" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-8">
        <SectionHeading
          kicker="热议榜"
          title="本周被反复截图的一组话题"
          desc="榜单按讨论度排出，每条都附一句短摘要，扫一眼就知道重点在哪。"
          actionLabel="完整榜单"
          actionHref="#overview"
        />

        <ol className="divide-y divide-background-200 border-y border-background-200">
          {rankingItems.map((item) => (
            <li key={item.rank}>
              <a
                href="#records"
                className="group flex items-start gap-4 px-1 py-4 transition-colors hover:bg-background-100 md:gap-6 md:px-3 md:py-5"
              >
                <span
                  className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-md font-heading text-base font-bold md:h-10 md:w-10 md:text-lg ${
                    item.rank <= 3
                      ? "bg-primary-500 text-background-50"
                      : "bg-background-200 text-foreground-700"
                  }`}
                >
                  {item.rank}
                </span>
                <div className="min-w-0 flex-1">
                  <div className="flex flex-wrap items-center gap-2">
                    <h3 className="font-heading text-base font-bold leading-snug text-foreground-950 group-hover:text-primary-600 md:text-lg">
                      {item.title}
                    </h3>
                    <span
                      className={`rounded-md px-1.5 py-0.5 text-[11px] font-semibold ${
                        tagStyles[item.tag] ?? "bg-secondary-100 text-secondary-900"
                      }`}
                    >
                      {item.tag}
                    </span>
                  </div>
                  <p className="mt-1.5 line-clamp-2 text-xs leading-relaxed text-foreground-600 md:text-sm">
                    {item.summary}
                  </p>
                </div>
                <div className="flex shrink-0 flex-col items-end gap-1">
                  <span className="inline-flex items-center gap-1 whitespace-nowrap text-xs font-semibold text-primary-600 md:text-sm">
                    <i className="ri-fire-line" />
                    {item.heat}
                  </span>
                  <i className="ri-arrow-right-up-line text-foreground-400 transition-transform group-hover:-translate-y-0.5" />
                </div>
              </a>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}